export default {
  en: {
    companyIntro: 'We are a globally leading provider of smart agricultural solutions, committed to simplifying farming processes.',
    
    ourCompany: 'About Fuhai International',
    companyOverview: `
      <div style="text-indent: 32px;margin-bottom: 10px">Fuhai Tonda International Machinery (Suzhou) Co., Ltd. was established in 2018 and is located in Suzhou, the capital of advanced manufacturing in China. The company is an agricultural machinery enterprise integrating R&D, production, and sales. It covers an area of more than 50 mu and has more than 200 employees. Leveraging local talent advantages, Fuhai International has assembled a high-quality team of engineers, focusing on the continuous innovation and R&D of efficient and durable agricultural machinery products. The company is committed to improving the assembly level, technical level, and performance of agricultural machinery, and to promoting product upgrades through new technologies, creating high-quality brand products.</div>
      <div style="text-indent: 32px;margin-bottom: 10px">In 2022, the company expanded its scale and established a production base in Weifang, Shandong Province, adopting internationally advanced development, design concepts, and production processes. The annual designed production capacity is 150,000 sets of mechanical equipment products, forming a complete and competitive industrial chain in the industry. The company's products are widely used in various agricultural scenarios such as farming, harvesting, field operations, and orchard management, providing stable and reliable agricultural machinery solutions for global agricultural users.</div>
      <div style="text-indent: 32px;margin-bottom: 10px">We take quality as the core and market as the guide, ensuring the improvement of product quality and competitiveness through synergy with production bases and technological innovation. "Excellence comes from details and responsibility; high-quality products come from standards and processes" is our philosophy of quality management and control.</div>
      <div  style="text-indent: 32px;margin-bottom: 10px">Our products are sold in more than 30 countries and regions around the world, successfully entering international markets such as Ukraine, Kazakhstan, Uzbekistan, Kyrgyzstan, Thailand, Indonesia, Myanmar, and Vietnam, becoming globally trusted star products and winning wide acclaim in both domestic and international markets.</div>
      <div style="text-indent: 32px;margin-bottom: 10px">We sincerely look forward to cooperating with you for mutual benefit and development!</div>
    `,
    
    productionScene: 'Production Scenes',
    
    // Our Story Section
    ourStory: 'Our Story',
    ourStoryIntro: 'We are a company specialized in the R&D, production, and export of agricultural machinery. Rooted in the vast farmlands of China, we have grown from a profound understanding of agriculture\'s future.',
    ourTeamComposition: 'Our Team Composition',
    teamType1: 'Agricultural machinery technology experts with postdoctoral backgrounds, hailing from frontline research',
    teamType2: 'Agricultural production technicians with years of experience in farming and field management',
    teamType3: 'Former farmers—frontline practitioners who best understand the land and real-world needs',
    ourStoryMission1: 'It is precisely this integration of research and agriculture that makes our products both technologically advanced and warmly intimate like those on the farm. We believe: Efficient, intelligent and reliable agricultural machinery should enter the fields of every country and serve every farmer.',
    ourStoryMission2: 'Therefore, we continuously optimize the design to enhance adaptability, usability and cost-effectiveness, and develop agricultural machinery equipment suitable for different national terrains and working habits. These products have gained popularity in emerging markets such as Asia, Africa and Latin America, the Middle East, and Eastern Europe.',
    ourStoryMission3:"Whether it is in the hilly fields of China, the paddy fields of Southeast Asia, the wheat fields of Central Asia, the red-soil farms of Africa, or the soybean plains of South America, we have always adhered to one core principle:",
    ourStoryQuote: 'Only those agricultural machines made by people who understand agriculture can truly be trusted.',
    
    // Existing core values translations
    quality: 'Quality',
    qualityDesc: 'Maintaining the highest standards in manufacturing',
    integrity: 'Integrity',
    innovation: 'Innovation',
    innovationDesc: 'Continuously developing cutting-edge agricultural technology',
    customerFocus: 'Customer First',
    customerFocusDesc: 'Dedicated to meeting and exceeding customer expectations',
    sustainability: 'Sustainability',
    sustainabilityDesc: 'Committed to environmental responsibility',
    
  
    
    // Company Stats
    yearsExperience: 'Years of Industry Experience',
    countriesServed: 'Countries and Regions Served',
    productsCount: 'Products in Our Portfolio',
    customerSatisfaction: 'Customer Satisfaction Rate',
    
    // Team Section
    ourTeam: 'Our Team',
    teamDescription: 'Our team of experts brings together decades of experience in agricultural machinery manufacturing and international trade.',
    
    // Core Advantages Section
    coreAdvantages: 'Core Advantages',
    advantage1: 'Smart Agriculture',
    advantage1Description: 'A globally leading provider of smart agricultural solutions, integrating R&D, production, and sales',
    advantage2: 'Leading Technology',
    advantage2Description: 'Spanning precision electronic manufacturing to agricultural machinery R&D, our core team has over 10 years of mechanical design experience',
    advantage3: 'Production Bases',
    advantage3Description: 'Leveraging the local agricultural machinery industry cluster in Weifang, we implement strict quality control, high-standard processes, and comprehensive supply chain management',
    advantage4: 'Global Market Reach',
    advantage4Description: 'Our business covers multiple regions worldwide, including the South and Middle Americas, Central Asia, Southeast Asia, and Africa, supported by a comprehensive sales network and after-sales service system',
    advantage5: 'FTZ Location Advantage',
    advantage5Description: 'Adjacent to Shanghai Port and Suzhou Port, we enjoy tariff preferences and facilitated customs clearance, reducing cross-border trade costs',
    advantage6: 'Global Service Capability',
    advantage6Description: 'We provide end-to-end one-stop services from procurement and logistics to after-sales support, with a professional team ensuring the smooth completion of every transaction',
    
    // Core Values Section
    customerFirst: 'Customer First',
    customerFirstDescription: 'Putting our customers\' needs at the forefront',
    excellence: 'Excellence',
    excellenceDescription: 'Striving for excellence in everything we do',
    teamwork: 'Teamwork',
    teamworkDescription: 'Working together to achieve common goals',
    innovationDescription: 'Continuously developing cutting-edge agricultural technology',
    
    // Company Culture Section
    companyCulture: 'Company Culture',
    cultureSubtitle: 'Our culture shapes our products, our values guide our decisions',
    cultureBannerTitle: 'Smart Agriculture · Global Vision',
    cultureBannerSubtitle: 'Innovation Drives Development, Quality Earns Trust',
    
    missionTitle: 'Mission',
    missionContent: 'Quality, Innovation, and becoming a globally leading smart agricultural solutions provider',

    visionTitle: 'Vision',
    visionContent: 'Make farming easier, increase yields, and empower sustainable agriculture worldwide',

    coreValuesTitle: 'Core Values',
    coreValuesContent: 'Integrity, Customer First, Win-Win Cooperation, and Pragmatic Action for Long-Term Development',
    
    integrityTitle: 'Integrity',
    integrityDesc: 'Honesty and trustworthiness',

    customerFirstTitle: 'Customer First',
    customerFirstDesc: 'Customer needs at the center',

    cooperationTitle: 'Win-Win Cooperation',
    cooperationDesc: 'Together for a better future',

    perseveranceTitle: 'Perseverance',
    perseveranceDesc: 'Steady progress, long-term success',
  },
  zh: {

    companyDescription: '作为农业机械领域的领先制造商，专注于拖拉机和农业设备，集研发、生产、销售和服务于一体',
    companyIntro: '我们是全球领先的智慧农业解决方案提供商，致力于简化耕作流程。',
    
    ourCompany: '关于福海国际',
    companyOverview: `
      <div style="text-indent: 32px;margin-bottom: 16px">福海通达国际机械（苏州）有限公司成立于2018年，坐落于中国先进制造业之都—苏州。公司是一家集研发、生产、销售于一体的农业机械企业。公司占地50余亩，员工200余人。依托本地人才优势，福海国际汇聚了一支高素质的工程师团队，专注于高效、耐用农业机械产品的持续创新与研发，公司致力于提升农业机械的装配水平、技术层次和使用性能，致力于以新技术推动产品的更新换代，打造优质名牌产品。</div>
      <div style="text-indent: 32px;margin-bottom: 16px">2022年公司扩大规模，在山东潍坊设立生产基地，采用国际先进的开发、设计理念和生产工艺，年设计生产15万套机械设备产品，在行业内形成了完整而有竞争力的产业链。公司产品广泛应用于耕种、收割、田间、果园管理等多种农业场景，从而为全球农业用户提供稳定可靠的农机解决方案。</div>
      <div style="text-indent: 32px;margin-bottom: 16px">我们以质量为核心，以市场为导向，通过与生产基地协同和技术创新确保提升产品质量和竞争力。“优秀源于细节与责任，精品出自标准和流程”是我们质量管理与控制的理念。</div>
      <div style="text-indent: 32px;margin-bottom: 16px">产品畅销全球三十多个国家和地区，成功进入乌克兰、哈萨克斯坦，乌斯别克斯坦，吉尔吉斯斯坦，泰国，印尼，缅甸、越南等国际市场，成为值得全球信赖的明星产品，赢得了国内外市场的广泛好评。</div>
      <div style="text-indent: 32px;">真诚期待与您合作，共赢、发展！</div>
    `,
    
    productionScene: '生产现场',
    
    // Our Story Section
    ourStory: '我们的故事',
    ourStoryIntro: '我们是一家专注于农业机械研发、生产与出口的公司，诞生于中国广袤的田野，成长于对农业未来的深刻理解。',
    ourTeamComposition: '我们的团队构成',
    teamType1: '来自科研一线、拥有博士后背景的农业机械技术专家',
    teamType2: '拥有多年耕作与田间管理经验的农业生产技术人员',
    teamType3: '曾经的农民，最懂土地与真实需求的一线实践者',
    ourStoryMission1: '正是这份跨越科研与土地的融合，让我们的产品既有科技的高度，又有农田的温度。我们相信：高效、智能、可靠的农业机械，应该走进世界各地的农田，服务每一位农人。',
    ourStoryMission2: '因此，我们不断优化设计，提升适应性、易用性与性价比，打造适合不同国家地形与作业习惯的农机设备，尤其在亚非拉、中东、东欧等新兴市场受到青睐。',
    ourStoryMission3: '无论是在中国的丘陵地块，东南亚的稻谷水田，中亚的麦田，还是在非洲的红土农场、南美的大豆平原，我们始终坚持一个理念。',
    ourStoryQuote: '懂农业的人做的农机，才真正值得信赖。',
    
    // Existing core values translations
    quality: '品质',
    qualityDesc: '在制造中保持最高标准',
    integrity: '诚信',
    innovation: '创新',
    innovationDesc: '持续开发尖端农业技术',
    customerFocus: '用户至上',
    customerFocusDesc: '致力于满足和超越客户期望',
    sustainability: '可持续发展',
    sustainabilityDesc: '致力于环境责任',
    
   
    
    // Company Stats
    yearsExperience: '行业经验年数',
    countriesServed: '服务的国家和地区',
    productsCount: '产品组合',
    customerSatisfaction: '客户满意度',
    
    // Team Section
    ourTeam: '我们的团队',
    teamDescription: '我们的专家团队汇集了数十年农业机械制造和国际贸易的经验。',
    
    // 核心优势部分
    coreAdvantages: '核心优势',
    advantage1: '智慧农业',
    advantage1Description: '全球领先的智慧农业解决方案提供商，集研发、生产、销售于一体',
    advantage2: '技术领先',
    advantage2Description: '从电子精密制造到农业机械研发，核心团队拥有10年+机械设计经验',
    advantage3: '生产基地',
    advantage3Description: '依托潍坊本地农业机械产业集群，严格质量控制，高标准流程，完善供应链管理',
    advantage4: '全球市场',
    advantage4Description: '业务覆盖中南美洲、中亚、东南亚、非洲等全球多个地区，完善的销售网络和售后服务体系',
    advantage5: '自贸区区位',
    advantage5Description: '紧邻上海港、苏州港，享受关税优惠与便捷通关，降低跨境贸易成本',
    advantage6: '全球化服务能力',
    advantage6Description: '提供从采购、物流到售后的全流程一站式服务，专业团队确保每一笔交易顺利完成',
    
    // Core Values Section
    customerFirst: '以客户为先',
    customerFirstDescription: '将客户需求置于首位',
    excellence: '追求卓越',
    excellenceDescription: '在所有工作中追求卓越',
    teamwork: '团队合作',
    teamworkDescription: '携手共进，实现共同目标',
    innovationDescription: '持续开发尖端农业技术',
    
    // Company Culture Section
    companyCulture: '企业文化',
    cultureSubtitle: '我们的文化塑造我们的产品，我们的价值观引导我们的决策',
    cultureBannerTitle: '智慧农业 · 全球视野',
    cultureBannerSubtitle: '以创新驱动发展，以品质赢得信赖',
    
    missionTitle: '使命',
    missionContent: '质量，创新，成为全球技术领先的智慧农业解决方案提供商',

    visionTitle: '愿景',
    visionContent: '让耕作更轻松，产量更高，助力全球农业可持续发展',

    coreValuesTitle: '核心价值观',
    coreValuesContent: '正直诚信、用户至上，合作共赢，敦行致远',
    
    integrityTitle: '正直诚信',
    integrityDesc: '诚实守信，值得信赖',

    customerFirstTitle: '用户至上',
    customerFirstDesc: '客户需求为中心',

    cooperationTitle: '合作共赢',
    cooperationDesc: '携手共创美好未来',

    perseveranceTitle: '敦行致远',
    perseveranceDesc: '脚踏实地，行稳致远',
  }
}